// extracted by mini-css-extract-plugin
module.exports = {"glacierWaveTreaserA":"A_glacierWaveTreaserA__I0H8U"};